var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-end mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex w-full gap-5 mdmax:w-full mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-full max-w-lg mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.search')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": _vm.$t('order.searchPlaceholder')
    },
    on: {
      "enter": function enter($event) {
        return _vm.doSearch();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)]), _c('div', {
    staticClass: "w-full max-w-xs mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.dateRange')))]), _c('div', {
    staticClass: "date-range relative text-xs"
  }, [_c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 z-1"
  }, [_c('Calendar', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('date-range-picker', {
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy',
        separator: ' - '
      },
      "showDropdowns": false,
      "timePicker": false,
      "timePicker24Hour": false,
      "ranges": false
    },
    on: {
      "update": _vm.setDate
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1)])]), _c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.addOrder'),
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": _vm.createOrder
    }
  }), _vm.user.is_upgraded ? _c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.uploadOrder'),
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": _vm.uploadOrder
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "bg-white shadow-md"
  }, [_c('div', {
    staticClass: "flex items-center tab shadow-border-b mdmax:overflow-x-auto"
  }, _vm._l(_vm.tabList, function (tab, index) {
    var _vm$selectedTab;

    return _c('div', {
      key: 'tab-' + index,
      staticClass: "relative px-6 py-3 cursor-pointer text-center font-medium flex items-center gap-2",
      class: [tab.value === ((_vm$selectedTab = _vm.selectedTab) === null || _vm$selectedTab === void 0 ? void 0 : _vm$selectedTab.value) ? 'active text-neutral-700' : 'text-neutral-500'],
      on: {
        "click": function click($event) {
          return _vm.selectTab(tab);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tab.label))]), tab.count !== undefined && tab.count > 0 ? _c('span', {
      staticClass: "text-xs px-2 py-0.5 rounded-full bg-red-500 text-white"
    }, [_vm._v(" " + _vm._s(tab.count) + " ")]) : _vm._e()]);
  }), 0), _vm.queries.status === 'DRAFT' ? _c('div', [_vm.filteredDraftData && _vm.filteredDraftData.length > 0 ? _c('div', {}, _vm._l(_vm.filteredDraftData, function (order) {
    return _c('div', {
      key: order.id
    }, [_c('DraftOrderCard', {
      attrs: {
        "data": order
      }
    })], 1);
  }), 0) : _c('div', {
    staticClass: "py-10 text-center"
  }, [_vm._v(_vm._s(_vm.$t('order.dataNotFound')))])]) : _c('div', [_vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {}, _vm._l(_vm.filteredData, function (order) {
    return _c('div', {
      key: order.id
    }, [_c('OrderCard', {
      attrs: {
        "data": order
      }
    })], 1);
  }), 0) : _c('div', {
    staticClass: "py-10 text-center"
  }, [_vm._v(_vm._s(_vm.$t('order.dataNotFound')))])])]), !_vm.isMobile && _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.show')) + " " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " " + _vm._s(_vm.$t('order.from')) + " " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.queries.page,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.queries.per_page
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }